import { useCallback, useEffect, useRef, useState } from 'react';
import { listChatNotesByUrl } from '../../../../api/chatNotes';

const BADGE_FETCH_LIMIT = 50;
const BADGE_MAX_COUNT = 99;

const useChatNotesBadgeCount = ({
  ownerId,
  buildListUrl,
  enabled = true,
}) => {
  const [noteCount, setNoteCount] = useState(0);
  const buildListUrlRef = useRef(buildListUrl);
  const requestIdRef = useRef(0);

  useEffect(() => {
    buildListUrlRef.current = buildListUrl;
  }, [buildListUrl]);

  const refreshNoteCount = useCallback(async () => {
    const nextRequestId = requestIdRef.current + 1;
    requestIdRef.current = nextRequestId;

    if (!enabled || !ownerId || typeof buildListUrlRef.current !== 'function') {
      setNoteCount(0);
      return 0;
    }

    try {
      let offset = 0;
      let total = 0;
      let hasMore = true;

      while (hasMore && total <= BADGE_MAX_COUNT) {
        const json = await listChatNotesByUrl(buildListUrlRef.current(ownerId, offset, BADGE_FETCH_LIMIT));
        const rows = Array.isArray(json?.notes) ? json.notes : [];
        total += rows.length;
        hasMore = rows.length === BADGE_FETCH_LIMIT;
        offset += rows.length;
      }

      const resolvedCount = total > BADGE_MAX_COUNT ? BADGE_MAX_COUNT + 1 : total;
      if (requestIdRef.current === nextRequestId) {
        setNoteCount(resolvedCount);
      }
      return resolvedCount;
    } catch (error) {
      if (requestIdRef.current === nextRequestId) {
        setNoteCount(0);
      }
      console.error('note badge count fetch error:', error);
      return 0;
    }
  }, [enabled, ownerId]);

  useEffect(() => {
    refreshNoteCount();
  }, [refreshNoteCount]);

  return {
    noteCount,
    refreshNoteCount,
  };
};

export default useChatNotesBadgeCount;
